import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import PropTypes from 'prop-types';
import { Grid, LoadingAnimation, Heading, Paragraph } from 'components/ui';
import TermsPublicFooter from 'components/TermsPublicFooter.jsx';
import BuyGiftCardError from './BuyGiftCardError.jsx';
import BuyGiftCardForm from './BuyGiftCardForm.jsx';
import BuyGiftCardInvoice from './BuyGiftCardInvoice.jsx';
import BuyGiftCardKyc from './BuyGiftCardKyc.jsx';
import BuyGiftCardSuccess from './BuyGiftCardSuccess.jsx';
import BuyGiftCardLogin from './BuyGiftCardLogin.jsx';
import classnames from 'classnames';

export class BuyGiftCardPage extends React.Component {
    static propTypes = {
        view: PropTypes.object.isRequired,
        trans: PropTypes.func.isRequired,
        homeLink: PropTypes.string.isRequired,
        isChristmas: PropTypes.bool,
    };

    render() {
        const { view, trans, homeLink, isChristmas, ...restProps } = this.props;

        return (
            <div
                className={classnames('u-pb-4', {
                    giftcardBackground: !isChristmas,
                    christmasBackground: isChristmas,
                })}
            >
                <Grid className="buyGiftCardPage" md="6|6">
                    <div className="buyGiftCardAside">
                        <div
                            className={classnames('buyGiftCardIllustrationWrapper', {
                                christmasIllustrationWrapper: isChristmas,
                                giftCardIllustrationWrapper: !isChristmas,
                            })}
                        >
                            <div
                                className={classnames('buyGiftCardIllustration', {
                                    christmasIllustration: isChristmas,
                                    giftcardIllustration: !isChristmas,
                                })}
                            />
                        </div>
                        <div
                            className={classnames('buyGiftCardAsideContent', {
                                christmasAside: isChristmas,
                                giftcardAside: !isChristmas,
                            })}
                        >
                            <Heading className="u-mb-4" size={1}>
                                {trans('buyGiftCard.aside.title')}
                            </Heading>
                            <Paragraph size="x-large" className="u-mb-4">
                                {trans('buyGiftCard.aside.content')}
                            </Paragraph>
                            <Paragraph
                                size="x-large"
                                className="u-mb-4"
                                dangerouslySetInnerHTML={{
                                    __html: trans('buyGiftCard.aside.boring'),
                                }}
                            />
                        </div>
                    </div>
                    {view.case({
                        Form: () => <BuyGiftCardForm {...restProps} />,
                        Invoice: () => <BuyGiftCardInvoice {...restProps} />,
                        Success: () => <BuyGiftCardSuccess {...restProps} homeLink={homeLink} />,
                        Error: () => <BuyGiftCardError {...restProps} />,
                        Kyc: () => <BuyGiftCardKyc {...restProps} />,
                        Login: () => <BuyGiftCardLogin {...restProps} />,
                        Loading: () => <LoadingAnimation type="spinner" />,
                    })}
                </Grid>
                <TermsPublicFooter isWhite />
            </div>
        );
    }
}

export default connectToI18n(BuyGiftCardPage);
